import { AgentCommon } from '~/agents/common/common/agent'

export const LegalAssistantAgentCommon: AgentCommon = {
  key: 'legalAssistant',
  hasOnboarding: false,
  hasSettings: false,
  guidelines: [],

  rulesCleaning: {
    deleteAll: [
      {
        key: { not: 'main' },
      },
    ],
  },
}
